export default __webpack_public_path__ + "static/media/sol.d88b76f8.svg";